import { useCallback, useEffect, useState } from 'react'

/**
 * Review states for one lemma's forms (for समीक्षाधीन badges in tables).
 * Returns a lookup; keys the database does not list are needs_review.
 */
export const useLemmaStatuses = (entity: string, lemma: string | null | undefined): (key: string) => string => {
    const [map, setMap] = useState<Record<string, string>>({})

    useEffect(() => {
        if (!lemma) return

        let cancelled = false

        fetch(`/api/review/statuses?entity=${encodeURIComponent(entity)}&lemma=${encodeURIComponent(lemma)}`)
            .then(res => (res.ok ? res.json() : { statuses: {} }))
            .then((data: { statuses?: Record<string, string> }) => {
                if (!cancelled) setMap(data.statuses ?? {})
            })
            .catch(() => undefined)

        return () => {
            cancelled = true
        }
    }, [entity, lemma])

    return useCallback((key: string) => map[key] ?? 'needs_review', [map])
}

/** Review states for an explicit list of keys. */
export const useKeyStatuses = (keys: string[]): (key: string) => string => {
    const [map, setMap] = useState<Record<string, string>>({})
    const joined = keys.join('\n')

    useEffect(() => {
        const list = joined ? joined.split('\n') : []

        if (list.length === 0) return

        let cancelled = false

        fetch('/api/review/statuses', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ keys: list })
        })
            .then(res => (res.ok ? res.json() : { statuses: {} }))
            .then((data: { statuses?: Record<string, string> }) => {
                if (!cancelled) setMap(data.statuses ?? {})
            })
            .catch(() => undefined)

        return () => {
            cancelled = true
        }
    }, [joined])

    return useCallback((key: string) => map[key] ?? 'needs_review', [map])
}
